import useDialog from './useDialog'
import { ICancelRideProps } from '../components/dialogs/CancelRide/CancelRideDialog'

const useCancelRideDialog = () => useDialog<ICancelRideProps>('cancel-ride-dialog')

export default useCancelRideDialog
